module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_upper_lower_lip.4a7694a3.jpg";